var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApartmentsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.3269 78.9993H1.47731C0.68917 78.9993 0 78.3077 0 77.5184V74.5557C0 73.7656 0.689874 73.0747 1.47731 73.0747H4.43266L4.43197 1.48097C4.43197 0.69088 5.12185 0 5.90928 0H38.0222C38.8103 0 39.4995 0.691585 39.4995 1.48097V23.4035H73.09C73.8782 23.4035 74.5673 24.0951 74.5673 24.8844V73.1732H77.5227C78.3108 73.1732 79 73.8648 79 74.6542V77.6168C78.8042 78.3084 78.1143 79 77.3269 79V78.9993ZM33.5902 73.1733V55.5958H23.3453V73.1733H33.5902ZM10.2443 73.1733H20.4886L20.4893 55.5958H10.2443L10.2443 73.1733ZM19.0114 5.82576H10.2443V14.6145H19.0114V5.82576ZM19.0114 20.4413H10.2443V29.23H19.0114V20.4413ZM19.0114 35.1547H10.2443V43.9434H19.0114V35.1547ZM33.5908 5.82593H24.8237V14.6147H33.5908V5.82593ZM33.5908 20.4415H24.8237V29.2302H33.5908V20.4415ZM33.5908 35.1549H24.8237V43.9436H33.5908V35.1549ZM36.4471 49.7697H7.28933V52.7324H36.4471V49.7697ZM53.9811 29.2297H45.2141V38.0184H53.9811V29.2297ZM53.9811 43.8445H45.2141V52.6333H53.9811V43.8445ZM53.9811 58.5579H45.2141V67.3467H53.9811V58.5579ZM68.5605 29.2292H59.7935V38.0179H68.5605V29.2292ZM68.5605 43.844H59.7935V52.6327H68.5605V43.844ZM68.5605 58.5574H59.7935V67.3461H68.5605V58.5574Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApartmentsIcon);
export default __webpack_public_path__ + "static/media/apartmentsIcon.2dd23ce0088b2775d156cb3727fb1cf6.svg";
export { ForwardRef as ReactComponent };